import React from "react";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import UnauthMenu from "../User/UnauthMenu";
import AuthMenu from "../User/Auth/AuthMenu";

// component
const User = ({ isDisabled = false, onFocusScroll }) => {
    const { currentUser } = useSiteHeader();
    const isAnonymous = currentUser?.isAnonymous ?? true;

    return isAnonymous ? (
        <UnauthMenu isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
    ) : (
        <AuthMenu isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
    );
};

export default User;

import PropTypes from "prop-types";

// prop-types
User.propTypes = {
    isDisabled: PropTypes.bool,
    onFocusScroll: PropTypes.func
};
